import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { LanguageMenu } from "./LanguageMenu";
import { useLanguage } from "@/i18n/LanguageContext";
import { scrollToId } from "@/lib/scroll";

const SUPPORT_EMAIL = "teamup.dev.app@gmail.com";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="teamup-footer-section" className="relative overflow-hidden border-t border-white/[0.07]">
      <div className="mx-auto max-w-7xl px-5 pt-20 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-outline pointer-events-none select-none whitespace-nowrap text-center font-display text-[clamp(3.5rem,14.5vw,13rem)] font-extrabold uppercase leading-none"
          aria-hidden="true"
        >
          TEAMUP
        </motion.div>

        <div className="mt-4 flex flex-col gap-10 border-t border-white/[0.07] py-12 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-mist">{t.footer.tagline}</p>
          </div>

          <nav className="flex flex-col gap-3.5 text-sm">
            <Link data-testid="teamup-privacy-policy-link" to="/privacy" className="w-fit text-white/60 transition-colors duration-300 hover:text-brand">
              {t.footer.privacy}
            </Link>
            <Link data-testid="teamup-terms-conditions-link" to="/terms" className="w-fit text-white/60 transition-colors duration-300 hover:text-brand">
              {t.footer.terms}
            </Link>
            <button
              type="button"
              data-testid="footer-support-link"
              onClick={() => scrollToId("support")}
              className="w-fit text-left text-white/60 transition-colors duration-300 hover:text-brand"
            >
              {t.footer.support}
            </button>
            <a
              data-testid="footer-contact-link"
              href={`mailto:${SUPPORT_EMAIL}`}
              className="w-fit text-white/60 transition-colors duration-300 hover:text-brand"
            >
              {t.footer.contact}
            </a>
          </nav>

          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">{t.footer.language}</span>
            <LanguageMenu testid="teamup-footer-language-switcher" />
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 border-t border-white/[0.07] py-7 sm:flex-row sm:items-center">
          <p className="text-xs text-white/40">{t.footer.rights}</p>
          <div className="flex items-center gap-6">
            <Link
              data-testid="footer-bottom-privacy-link"
              to="/privacy"
              className="text-xs text-white/50 transition-colors duration-300 hover:text-brand"
            >
              {t.footer.privacy}
            </Link>
            <Link
              data-testid="footer-bottom-terms-link"
              to="/terms"
              className="text-xs text-white/50 transition-colors duration-300 hover:text-brand"
            >
              {t.footer.terms}
            </Link>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand/60">teamup-app.fr</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
